import { render, staticRenderFns } from "./InsuranceData.vue?vue&type=template&id=33761bc8&scoped=true"
import script from "./InsuranceData.vue?vue&type=script&lang=js"
export * from "./InsuranceData.vue?vue&type=script&lang=js"
import style0 from "./InsuranceData.vue?vue&type=style&index=0&id=33761bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33761bc8",
  null
  
)

export default component.exports